var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_82_363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.828 9.82812C11.3875 9.26876 11.7686 8.55603 11.9231 7.78007C12.0775 7.00412 11.9984 6.19979 11.6956 5.46881C11.3929 4.73784 10.8802 4.11305 10.2224 3.67347C9.56459 3.23389 8.79118 2.99927 8 2.99927C7.20883 2.99927 6.43542 3.23389 5.7776 3.67347C5.11977 4.11305 4.60708 4.73784 4.30437 5.46881C4.00165 6.19979 3.92251 7.00412 4.07695 7.78007C4.23139 8.55603 4.61247 9.26876 5.172 9.82812L8 12.6571L10.828 9.82812Z",
    stroke: "#F92950",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 7V7.01167",
    stroke: "#F92950",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.828 17.8279C19.3875 17.2685 19.7686 16.5558 19.9231 15.7798C20.0775 15.0039 19.9984 14.1995 19.6956 13.4686C19.3929 12.7376 18.8802 12.1128 18.2224 11.6732C17.5646 11.2337 16.7912 10.999 16 10.999C15.2088 10.999 14.4354 11.2337 13.7776 11.6732C13.1198 12.1128 12.6071 12.7376 12.3044 13.4686C12.0017 14.1995 11.9225 15.0039 12.0769 15.7798C12.2314 16.5558 12.6125 17.2685 13.172 17.8279L16 20.6569L18.828 17.8279Z",
    stroke: "#F92950",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 15V15.0117",
    stroke: "#F92950",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_82_363"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon4);
export default __webpack_public_path__ + "static/media/account-icon4.8dc68b4ac0a1dd53192445b0d8186f8e.svg";
export { ForwardRef as ReactComponent };